import { Delegate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

let _delegate, 
	_CollectionViewSwitch_instances, 
	onViewSwitch_fn,
	setCartAttribute_fn;
	
let CollectionViewSwitchGHD = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CollectionViewSwitch_instances);
    __privateAdd(this, _delegate, new Delegate(this));
  }
  connectedCallback() {
    __privateGet(this, _delegate).on("click", 'button[type="button"]', __privateMethod(this, _CollectionViewSwitch_instances, onViewSwitch_fn).bind(this));
  }
  get controlledList() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
_delegate = new WeakMap();
_CollectionViewSwitch_instances = new WeakSet();
onViewSwitch_fn = function(event, target) {
  if (target.classList.contains("is-active")) {
    return;
  }
  this.controlledList.setAttribute(`collection-view`, target.value);
  Array.from(this.querySelectorAll("button")).forEach((item) => item.classList.toggle("is-active", item === target));
  this.controlledList.reveal();
  __privateMethod(this, _CollectionViewSwitch_instances, setCartAttribute_fn).call(this, target.value);
};
setCartAttribute_fn = function(newLayout) {
  const attributeProperty = `products_view_mode`;
  fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        [attributeProperty]: newLayout
      }
    }),
    keepalive: true
    // Allows to make sure the request is fired even when submitting the form
  });
};

if (!window.customElements.get("collection-view-switch-ghd")) {
  window.customElements.define("collection-view-switch-ghd", CollectionViewSwitchGHD);
}

export {
	CollectionViewSwitchGHD
};

